// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EquipeModalContent_picker__2mgrX {\n  margin: 8px;\n  width: calc(100% - 28px);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Equipe/EquipeModalContent.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;AAC1B","sourcesContent":[".picker {\n  margin: 8px;\n  width: calc(100% - 28px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"picker": "EquipeModalContent_picker__2mgrX"
};
export default ___CSS_LOADER_EXPORT___;
